import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import t from "../request.js";
import r from "../core/Error.js";
import { clone as o } from "../core/lang.js";
import { MultiOriginJSONMixin as i } from "../core/MultiOriginJSONSupport.js";
import { throwIfAbortError as s, createTask as l } from "../core/promiseUtils.js";
import { urlToObject as a, addQueryParameters as n, isProtocolRelative as p, normalize as y } from "../core/urlUtils.js";
import { property as u } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { reader as c } from "../core/accessorSupport/decorators/reader.js";
import { subclass as m } from "../core/accessorSupport/decorators/subclass.js";
import { writer as h } from "../core/accessorSupport/decorators/writer.js";
import d from "../geometry/Extent.js";
import f from "../geometry/SpatialReference.js";
import S from "./Layer.js";
import { APIKeyMixin as g } from "./mixins/APIKeyMixin.js";
import { ArcGISCachedService as v } from "./mixins/ArcGISCachedService.js";
import { ArcGISService as _ } from "./mixins/ArcGISService.js";
import { BlendLayer as j } from "./mixins/BlendLayer.js";
import { CustomParametersMixin as b } from "./mixins/CustomParametersMixin.js";
import { OperationalLayer as I } from "./mixins/OperationalLayer.js";
import { PortalLayer as T } from "./mixins/PortalLayer.js";
import { ScaleRangeLayer as w } from "./mixins/ScaleRangeLayer.js";
import { checkWebPSupport as L } from "./support/imageUtils.js";
import x from "./support/SpriteSource.js";
import U from "./support/TileInfo.js";
import { loadMetadata as O } from "./support/vectorTileLayerLoader.js";
import { createForItem as P } from "../portal/support/jsonContext.js";
import R from "../views/2d/engine/vectorTiles/SchemaHelper.js";
import { areSchemasOverlapping as M, unionTileInfos as V } from "../views/2d/engine/vectorTiles/tileInfoUtils.js";
import C from "../views/2d/engine/vectorTiles/style/StyleRepository.js";
import D from "../views/webgl/capabilities.js";

var k = /*#__PURE__*/function (_j) {
  _inherits(k, _j);

  var _super = _createSuper(k);

  function k() {
    var _this;

    _classCallCheck(this, k);

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(e)), _this._spriteSourceMap = new Map(), _this.currentStyleInfo = null, _this.style = null, _this.isReference = null, _this.operationalLayerType = "VectorTileLayer", _this.type = "vector-tile", _this.url = null, _this.symbolCollisionBoxesVisible = !1, _this.path = null;
    return _this;
  }

  _createClass(k, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e, t) {
      return "string" == typeof e ? _objectSpread({
        url: e
      }, t) : e;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._spriteSourceMap.clear();
    }
  }, {
    key: "prefetchResources",
    value: function () {
      var _prefetchResources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadSpriteSource(globalThis.devicePixelRatio || 1, e);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prefetchResources(_x) {
        return _prefetchResources.apply(this, arguments);
      }

      return prefetchResources;
    }()
  }, {
    key: "load",
    value: function load(e) {
      var _this2 = this;

      var r = this.loadFromPortal({
        supportedTypes: ["Vector Tile Service"],
        supportsData: !1
      }, e).catch(s).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var r;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this2.portalItem || !_this2.portalItem.id)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                r = "".concat(_this2.portalItem.itemUrl, "/resources/styles/root.json");
                _context2.next = 5;
                return t(r, _objectSpread(_objectSpread({}, e), {}, {
                  query: _objectSpread(_objectSpread({
                    f: "json"
                  }, _this2.customParameters), {}, {
                    token: _this2.apiKey
                  })
                }));

              case 5:
                _context2.t0 = _context2.sent.data;

                if (!_context2.t0) {
                  _context2.next = 8;
                  break;
                }

                _this2.read({
                  url: r
                }, P(_this2.portalItem));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))).catch(s).then(function () {
        return _this2._loadStyle(e);
      });
      return this.addResolvingPromise(r), Promise.resolve(this);
    }
  }, {
    key: "attributionDataUrl",
    get: function get() {
      var e = this.currentStyleInfo,
          t = e && e.serviceUrl && a(e.serviceUrl);
      if (!t) return null;

      var r = this._getDefaultAttribution(t.path);

      return r ? n(r, _objectSpread(_objectSpread({}, this.customParameters), {}, {
        token: this.apiKey
      })) : null;
    }
  }, {
    key: "capabilities",
    get: function get() {
      var e = this.primarySource;
      return e ? e.capabilities : {
        operations: {
          supportsExportTiles: !1,
          supportsTileMap: !1
        },
        exportTiles: null
      };
    }
  }, {
    key: "fullExtent",
    get: function get() {
      var e;
      return (null == (e = this.primarySource) ? void 0 : e.fullExtent) || null;
    }
  }, {
    key: "parsedUrl",
    get: function get() {
      return this.serviceUrl ? a(this.serviceUrl) : null;
    }
  }, {
    key: "serviceUrl",
    get: function get() {
      return this.currentStyleInfo && this.currentStyleInfo.serviceUrl || null;
    }
  }, {
    key: "spatialReference",
    get: function get() {
      return this.tileInfo && this.tileInfo.spatialReference || null;
    }
  }, {
    key: "styleUrl",
    get: function get() {
      return this.currentStyleInfo && this.currentStyleInfo.styleUrl || null;
    }
  }, {
    key: "writeStyleUrl",
    value: function writeStyleUrl(e, t) {
      e && p(e) && (e = "https:".concat(e)), t.styleUrl = e;
    }
  }, {
    key: "tileInfo",
    get: function get() {
      var e;
      var t = [];

      for (var _o in this.sourceNameToSource) {
        t.push(this.sourceNameToSource[_o]);
      }

      var r = (null == (e = this.primarySource) ? void 0 : e.tileInfo) || new U();
      if (t.length > 1) for (var _o2 = 0; _o2 < t.length; _o2++) {
        M(r, t[_o2].tileInfo) && (r = V(r, t[_o2].tileInfo));
      }
      return r;
    }
  }, {
    key: "readVersion",
    value: function readVersion(e, t) {
      return t.version ? parseFloat(t.version) : parseFloat(t.currentVersion);
    }
  }, {
    key: "compatibleTileInfo256",
    get: function get() {
      return R.create256x256CompatibleTileInfo(this.tileInfo);
    }
  }, {
    key: "compatibleTileInfo512",
    get: function get() {
      return R.create512x512CompatibleTileInfo(this.tileInfo);
    }
  }, {
    key: "loadSpriteSource",
    value: function () {
      var _loadSpriteSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var e,
            t,
            r,
            _o3,
            _i,
            _s,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                e = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 1;
                t = _args3.length > 1 ? _args3[1] : undefined;

                if (this._spriteSourceMap.has(e)) {
                  _context3.next = 7;
                  break;
                }

                _o3 = D(), _i = null != (r = this.currentStyleInfo) && r.spriteUrl ? n(this.currentStyleInfo.spriteUrl, _objectSpread(_objectSpread({}, this.customParameters), {}, {
                  token: this.apiKey
                })) : null, _s = new x(_i, e, _o3.maxTextureSize, this.currentStyleInfo.spriteFormat);
                _context3.next = 6;
                return _s.load(t);

              case 6:
                this._spriteSourceMap.set(e, _s);

              case 7:
                return _context3.abrupt("return", Promise.resolve(this._spriteSourceMap.get(e)));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadSpriteSource() {
        return _loadSpriteSource.apply(this, arguments);
      }

      return loadSpriteSource;
    }()
  }, {
    key: "loadStyle",
    value: function () {
      var _loadStyle2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t) {
        var _this3 = this;

        var r, o;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                o = e || this.style || this.url;
                return _context4.abrupt("return", (this._loadingTask && "string" == typeof o && this.url === o || (null == (r = this._loadingTask) || r.abort(), this._loadingTask = l(function (e) {
                  return _this3._spriteSourceMap.clear(), _this3._getSourceAndStyle(o, {
                    signal: e
                  });
                }, t)), this._loadingTask.promise));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadStyle(_x2, _x3) {
        return _loadStyle2.apply(this, arguments);
      }

      return loadStyle;
    }()
  }, {
    key: "getStyleLayerId",
    value: function getStyleLayerId(e) {
      return this.styleRepository.getStyleLayerId(e);
    }
  }, {
    key: "getStyleLayerIndex",
    value: function getStyleLayerIndex(e) {
      return this.styleRepository.getStyleLayerIndex(e);
    }
  }, {
    key: "getPaintProperties",
    value: function getPaintProperties(e) {
      return o(this.styleRepository.getPaintProperties(e));
    }
  }, {
    key: "setPaintProperties",
    value: function setPaintProperties(e, t) {
      var r = this.styleRepository.isPainterDataDriven(e);
      this.styleRepository.setPaintProperties(e, t);
      var o = this.styleRepository.isPainterDataDriven(e);
      this.emit("paint-change", {
        layer: e,
        paint: t,
        isDataDriven: r || o
      });
    }
  }, {
    key: "getStyleLayer",
    value: function getStyleLayer(e) {
      return o(this.styleRepository.getStyleLayer(e));
    }
  }, {
    key: "setStyleLayer",
    value: function setStyleLayer(e, t) {
      this.styleRepository.setStyleLayer(e, t), this.emit("style-layer-change", {
        layer: e,
        index: t
      });
    }
  }, {
    key: "deleteStyleLayer",
    value: function deleteStyleLayer(e) {
      this.styleRepository.deleteStyleLayer(e), this.emit("delete-style-layer", {
        layer: e
      });
    }
  }, {
    key: "getLayoutProperties",
    value: function getLayoutProperties(e) {
      return o(this.styleRepository.getLayoutProperties(e));
    }
  }, {
    key: "setLayoutProperties",
    value: function setLayoutProperties(e, t) {
      this.styleRepository.setLayoutProperties(e, t), this.emit("layout-change", {
        layer: e,
        layout: t
      });
    }
  }, {
    key: "setStyleLayerVisibility",
    value: function setStyleLayerVisibility(e, t) {
      this.styleRepository.setStyleLayerVisibility(e, t), this.emit("style-layer-visibility-change", {
        layer: e,
        visibility: t
      });
    }
  }, {
    key: "getStyleLayerVisibility",
    value: function getStyleLayerVisibility(e) {
      return this.styleRepository.getStyleLayerVisibility(e);
    }
  }, {
    key: "write",
    value: function write(e, t) {
      return t && t.origin && !this.styleUrl ? (t.messages && t.messages.push(new r("vectortilelayer:unsupported", "VectorTileLayer (".concat(this.title, ", ").concat(this.id, ") with style defined by JSON only are not supported"), {
        layer: this
      })), null) : _get(_getPrototypeOf(k.prototype), "write", this).call(this, e, t);
    }
  }, {
    key: "getTileUrl",
    value: function getTileUrl(e, t, r) {
      return null;
    }
  }, {
    key: "_getSourceAndStyle",
    value: function () {
      var _getSourceAndStyle2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (e) {
                  _context5.next = 2;
                  break;
                }

                throw new Error("invalid style!");

              case 2:
                _context5.next = 4;
                return O(e, _objectSpread(_objectSpread({}, t), {}, {
                  query: _objectSpread(_objectSpread({}, this.customParameters), {}, {
                    token: this.apiKey
                  })
                }));

              case 4:
                r = _context5.sent;

                if (!("webp" === r.spriteFormat)) {
                  _context5.next = 11;
                  break;
                }

                _context5.next = 8;
                return L("lossy");

              case 8:
                _context5.t0 = _context5.sent;

                if (_context5.t0) {
                  _context5.next = 11;
                  break;
                }

                r.spriteFormat = "png";

              case 11:
                this._set("currentStyleInfo", _objectSpread({}, r)), "string" == typeof e ? (this.url = e, this.style = null) : (this.url = null, this.style = e), this._set("sourceNameToSource", r.sourceNameToSource), this._set("primarySource", r.sourceNameToSource[r.primarySourceName]), this._set("styleRepository", new C(r.style)), this.read(r.layerDefinition, {
                  origin: "service"
                }), this.emit("load-style");

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _getSourceAndStyle(_x4, _x5) {
        return _getSourceAndStyle2.apply(this, arguments);
      }

      return _getSourceAndStyle;
    }()
  }, {
    key: "_getDefaultAttribution",
    value: function _getDefaultAttribution(e) {
      var t = e.match(/^https?:\/\/(?:basemaps|basemapsbeta|basemapsdev)(?:-api)?\.arcgis\.com(\/[^\/]+)?\/arcgis\/rest\/services\/([^\/]+(\/[^\/]+)*)\/vectortileserver/i),
          r = ["OpenStreetMap_v2", "OpenStreetMap_Daylight_v2", "OpenStreetMap_Export_v2", "OpenStreetMap_FTS_v2", "OpenStreetMap_GCS_v2", "World_Basemap", "World_Basemap_v2", "World_Basemap_Export_v2", "World_Basemap_GCS_v2", "World_Basemap_WGS84", "World_Contours_v2"];
      if (!t) return;
      var o = t[2] && t[2].toLowerCase();
      if (!o) return;
      var i = t[1] || "";

      for (var _i2 = 0, _r = r; _i2 < _r.length; _i2++) {
        var _s2 = _r[_i2];
        if (_s2.toLowerCase().includes(o)) return y("//static.arcgis.com/attribution/Vector".concat(i, "/").concat(_s2));
      }
    }
  }, {
    key: "_loadStyle",
    value: function () {
      var _loadStyle3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
        var t, r;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", null != (t = null == (r = this._loadingTask) ? void 0 : r.promise) ? t : this.loadStyle(null, e));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _loadStyle(_x6) {
        return _loadStyle3.apply(this, arguments);
      }

      return _loadStyle;
    }()
  }]);

  return k;
}(j(w(v(_(I(T(b(g(i(S))))))))));

e([u({
  readOnly: !0
})], k.prototype, "attributionDataUrl", null), e([u({
  type: ["show", "hide"]
})], k.prototype, "listMode", void 0), e([u({
  readOnly: !0,
  json: {
    read: !1
  }
})], k.prototype, "capabilities", null), e([u({
  readOnly: !0
})], k.prototype, "currentStyleInfo", void 0), e([u({
  json: {
    read: !1
  },
  readOnly: !0,
  type: d
})], k.prototype, "fullExtent", null), e([u()], k.prototype, "style", void 0), e([u({
  type: Boolean,
  json: {
    read: !1,
    write: {
      enabled: !0,
      overridePolicy: function overridePolicy() {
        return {
          enabled: !1
        };
      }
    }
  }
})], k.prototype, "isReference", void 0), e([u({
  type: ["VectorTileLayer"]
})], k.prototype, "operationalLayerType", void 0), e([u({
  readOnly: !0
})], k.prototype, "parsedUrl", null), e([u({
  readOnly: !0
})], k.prototype, "serviceUrl", null), e([u({
  type: f,
  readOnly: !0
})], k.prototype, "spatialReference", null), e([u({
  readOnly: !0
})], k.prototype, "styleRepository", void 0), e([u({
  readOnly: !0
})], k.prototype, "sourceNameToSource", void 0), e([u({
  readOnly: !0
})], k.prototype, "primarySource", void 0), e([u({
  type: String,
  readOnly: !0,
  json: {
    write: {
      ignoreOrigin: !0
    },
    origins: {
      "web-document": {
        write: {
          ignoreOrigin: !0,
          isRequired: !0
        }
      }
    }
  }
})], k.prototype, "styleUrl", null), e([h(["portal-item", "web-document"], "styleUrl")], k.prototype, "writeStyleUrl", null), e([u({
  json: {
    read: !1,
    origins: {
      service: {
        read: !1
      }
    }
  },
  readOnly: !0,
  type: U
})], k.prototype, "tileInfo", null), e([u({
  json: {
    read: !1
  },
  readOnly: !0,
  value: "vector-tile"
})], k.prototype, "type", void 0), e([u({
  json: {
    origins: {
      "web-document": {
        read: {
          source: "styleUrl"
        }
      },
      "portal-item": {
        read: {
          source: "url"
        }
      }
    },
    write: !1,
    read: !1
  }
})], k.prototype, "url", void 0), e([u({
  readOnly: !0
})], k.prototype, "version", void 0), e([c("version", ["version", "currentVersion"])], k.prototype, "readVersion", null), e([u({
  readOnly: !0
})], k.prototype, "compatibleTileInfo256", null), e([u({
  readOnly: !0
})], k.prototype, "compatibleTileInfo512", null), e([u({
  type: Boolean
})], k.prototype, "symbolCollisionBoxesVisible", void 0), e([u({
  type: String,
  json: {
    origins: {
      "web-scene": {
        read: !0,
        write: !0
      }
    },
    read: !1
  }
})], k.prototype, "path", void 0), k = e([m("esri.layers.VectorTileLayer")], k);
var B = k;
export { B as default };